

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface CommunicationTemplateParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface CommunicationTemplate {
    id?: any;
    tenantId: any;
    branchId: any;
    name:any;
    commTemplateMessage:string;
    isActive:string;
    
    parameters?: CommunicationTemplateParameter[];
    links?: any;
}


export abstract class CommunicationTemplateData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<CommunicationTemplate[]>;
    abstract create(url: string, data: CommunicationTemplate): Observable<CommunicationTemplate[]>;
    abstract update(url: string, data: CommunicationTemplate): Observable<CommunicationTemplate>;
    abstract delete(url: string): Observable<any>;
}
